import React from "react";
import "./Footer.scss";
import logo from "../../../assets/HOQ-Logo.png";
import { Button, Form, Modal, Select } from "antd";
import { useState } from "react";
import TextArea from "antd/es/input/TextArea";

const Footer = () => {
  const [isOpenContact, setIsOpenContact] = useState(false);

  const handleContactSupport = () => {
    setIsOpenContact(true);
  };

  const onFinishContact = (values) => {
    console.log("Success:", values);
  };

  return (
    <div className="w-full border-t border-gray-200 flex justify-center items-center bg-white  ">
      <Modal
        title={
          <div className="contactTitle flex justify-between px-5 ">
            <span className="text-lg font-bold text-gray-900">
              Contact Support
            </span>
          </div>
        }
        open={isOpenContact}
        onCancel={() => setIsOpenContact(false)}
        centered
        footer={null}
        width={800}
        className="text-center contact-modal-main"
      >
        <div className="inner-content-box">
          <div className="text-base mb-6">
            <span>
              Please provide a reason for contacting support. We'll get back to
              you as soon as possible.
            </span>
          </div>
          <div>
            <Form
              name="contactAndSupport"
              onFinish={onFinishContact}
              autoComplete="off"
              layout="vertical"
            >
              <Form.Item
                label={
                  <span className="font-semibold text-base">
                    Select Reason :
                  </span>
                }
                name="reason"
                rules={[
                  {
                    required: true,
                    message: "Please select your reason!",
                  },
                ]}
              >
                <Select
                  size="large"
                  defaultValue="lucy"
                  options={[
                    {
                      value: "jack",
                      label: "Jack",
                    },
                    {
                      value: "lucy",
                      label: "Lucy",
                    },
                    {
                      value: "Yiminghe",
                      label: "yiminghe",
                    },
                    {
                      value: "disabled",
                      label: "Disabled",
                      disabled: true,
                    },
                  ]}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="font-semibold text-base">
                    Please Specify :
                  </span>
                }
                name="specify"
              >
                <TextArea
                  placeholder=""
                  size="large"
                  autoSize={{
                    minRows: 5,
                    maxRows: 5,
                  }}
                />
              </Form.Item>
            </Form>
          </div>
        </div>
        <div className="contact-modal-footer flex justify-end pt-5 border-t border-0 border-solid border-gray-200">
          <Form.Item label={null} className="mb-0">
            <Button
              type="primary"
              className="mr-3"
              htmlType="submit"
              size="large"
            >
              Submit
            </Button>
          </Form.Item>
          <Button size="large" onClick={() => setIsOpenContact(false)}>
            Cancel
          </Button>
        </div>
      </Modal>
      <div className="container mx-auto px-4 py-5">
        <div className="flex flex-col md:flex-row items-center justify-between text-sm">
          <div className="mb-2 md:mb-0">
            <span>
              HireQuick Online Recruitment Software ©{" "}
              {new Date().getFullYear()}
            </span>
          </div>

          <div className="mb-2 md:mb-0">
            <span>Facing any issues? </span>
            <Button
              type="link"
              className="ml-2 text-primary p-0 hover:!text-primary "
              onClick={handleContactSupport}
            >
              Contact Support
            </Button>
          </div>

          <div className="flex items-center">
            <span className="mr-2">Powered by:</span>
            <img src={logo} alt="Hirequick Logo" className="h-6" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
